/** @jsxImportSource @emotion/react */
import React from "react";
import { Button, Card, Col, Form, Row, Space } from "antd";
import {
  THEME_CONFIG_TEMPLATE,
  ThemeConfigFieldSchema,
  ThemeConfig,
  ThemeConfigure,
} from "../../../config/theme-configure";
import { INPUT_TYPE_REGISTRY } from "../inputTypeRegistry";
import * as Styles from "./styles";

interface ThemeConfigFormProps {
  initialValues?: ThemeConfig;
  onSave: (values: ThemeConfig) => void;
  loading?: boolean;
}

export const ThemeConfigForm: React.FC<ThemeConfigFormProps> = ({
  initialValues,
  onSave,
  loading,
}: ThemeConfigFormProps) => {
  const [form] = Form.useForm();

  const handleFinish = (values: ThemeConfig) => {
    onSave(values);
  };

  const handleResetDefault = () => {
    const defaults = ThemeConfigure.withDefaults({});
    form.setFieldsValue(defaults);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={ThemeConfigure.withDefaults(initialValues)}
      onFinish={handleFinish}
      css={Styles.formStyle}
    >
      <Row gutter={[24, 24]} css={Styles.sectionsRowStyle}>
        {Object.entries(THEME_CONFIG_TEMPLATE).map(
          ([section, sectionSchema]) => (
            <Col key={section} xs={24} md={12}>
              <Card
                type="inner"
                title={sectionSchema.label}
                css={Styles.sectionCard}
              >
                <Row gutter={[24, 0]}>
                  {Object.entries(sectionSchema.fields).map(
                    ([fieldKey, fieldSchema]: [
                      string,
                      ThemeConfigFieldSchema,
                    ]) => {
                      const FieldInput = INPUT_TYPE_REGISTRY[fieldSchema.type];
                      const isCheckbox = fieldSchema.type === "checkboxInput";
                      return (
                        <Col key={fieldKey} xs={24} sm={12} lg={8}>
                          <Form.Item
                            label={isCheckbox ? undefined : fieldSchema.label}
                            name={[section, fieldKey]}
                          >
                            <FieldInput field={fieldSchema} />
                          </Form.Item>
                        </Col>
                      );
                    },
                  )}
                </Row>
              </Card>
            </Col>
          ),
        )}
      </Row>
      <Form.Item css={Styles.actionsStyle}>
        <Space>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
          <Button onClick={handleResetDefault}>Reset to default</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
